import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import InvoiceSection from './InvoiceSection';
import DeliverySection from './DeliverySection';
import css from './CheckoutForm.css';

const CheckoutForm = props => {
  const { provider, initialValues: { email, firstName, lastName }, onSubmit, subscriptionTerms } = props;

  const methods = useForm({
    defaultValues: {
      deliveryType: 'pickup',
      invoiceType: 'individual',
      email,
      firstName,
      lastName,
      delivery: {
        countryId: 'PL',
      },
    },
    mode: 'onBlur',
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const handleFormSubmit = data => {
    const { invoice, invoiceType, delivery, deliveryType, firstName, lastName, email, phone } = data;

    const isPickup = deliveryType === 'pickup';
    console.log(delivery)
    const deliveryAttr = isPickup
      ? {
          deliveryToProviderId: delivery?.storeId || null,
        }
      : {
          deliveryToHomeAddress: {
            address: delivery?.streetAddress || '',
            address2: '',
            city: delivery?.postalCodeAndCity || '',
            countryId: 'pl',
          },
        };

    const meta = {
      customerType: invoiceType,
      invoice: {
        ...invoice,
        customerType: invoiceType,
      },
    };

    onSubmit({
      firstName,
      lastName,
      email: email?.trim(),
      phone,
      deliveryAttr,
      meta,
    });
  };

  return (
    <FormProvider {...methods}>
      <form id="checkout-form" onSubmit={handleSubmit(handleFormSubmit)} className={css.root}>
        <section className={css.section}>
          <h2 className={css.heading}>
            <FormattedMessage id="CheckoutForm.personalSection" />
          </h2>

          <div className={css.row}>
            <div className={css.field}>
              <label className={css.label}>
                <FormattedMessage id="CheckoutForm.firstName" />
              </label>
              <input
                {...register('firstName', { required: true })}
                className={errors.firstName ? css.inputError : css.input}
              />
            </div>
            <div className={css.field}>
              <label className={css.label}>
                <FormattedMessage id="CheckoutForm.lastName" />
              </label>
              <input
                {...register('lastName', { required: true })}
                className={errors.lastName ? css.inputError : css.input}
              />
            </div>
          </div>

          <div className={css.row}>
            <div className={css.field}>
              <label className={css.label}>
                <FormattedMessage id="CheckoutForm.email" />
              </label>
              <input
                type="email"
                {...register('email', { required: true, pattern: /^\S+@\S+$/i })}
                className={errors.email ? css.inputError : css.input}
              />
            </div>
            <div className={css.field}>
              <label className={css.label}>
                <FormattedMessage id="CheckoutForm.phone" />
              </label>
              <input
                type="tel"
                {...register('phone', { required: true })}
                className={errors.phone ? css.inputError : css.input}
              />
            </div>
          </div>
        </section>

        <DeliverySection
          provider={provider}
        />

        <InvoiceSection />

        <section className={css.consentSection}>
          <div className={css.checkboxField}>
            <label className={classNames(css.checkboxLabel, { [css.labelError]: errors.agreeToTerms })}>
              <input
                type="checkbox"
                {...register('agreeToTerms', { required: true })}
                className={css.checkbox}
              />
              <span className={css.consentText}>
                <FormattedMessage
                  id="CheckoutForm.consentTerms"
                  values={{
                    termsLink: (
                      <a href={subscriptionTerms} target="_blank" rel="noopener noreferrer" className={css.link}>
                        <FormattedMessage id="CheckoutForm.termsLinkText" />
                      </a>
                    ),
                  }}
                />
              </span>
            </label>

            {errors.agreeToTerms && (
              <span className={css.errorMessage}>
                <FormattedMessage id="CheckoutForm.termsRequiredError" />
              </span>
            )}
          </div>

          <div className={css.adminInfo}>
            <p className={css.adminText}>
              <FormattedMessage id="CheckoutForm.adminInfo" />
            </p>
          </div>
        </section>
      </form>
    </FormProvider>
  );
};

export default injectIntl(CheckoutForm);